import * as React from 'react';
import {Box, IconButton} from '@mui/material';
import {DataGrid, GridColDef, GridRenderCellParams} from '@mui/x-data-grid';
import DownloadIcon from '@mui/icons-material/Download';
import {useTranslation} from 'react-i18next';

// Define the structure of a document row
interface DocumentRow {
    id: number;
    fileName: string;
    matter: string;
    lastUpdated: string;
}

export default function DocumentsTableView(): React.ReactElement {
    const {t} = useTranslation();
    const rows: DocumentRow[] = [
        {id: 1, fileName: 'File name 1', matter: "Nuto files", lastUpdated: "17.1.2025"},
        {id: 2, fileName: 'File name 2', matter: "Complience", lastUpdated: "17.1.2025"},
        {id: 3, fileName: 'File name 3', matter: "Legal Forms", lastUpdated: "17.1.2025"},
        {id: 4, fileName: 'File name 4', matter: "Nuto", lastUpdated: "17.1.2025"},
        {id: 5, fileName: 'File name 5', matter: "My company", lastUpdated: "17.1.2025"},
        {id: 6, fileName: 'File name 6', matter: "Nuto", lastUpdated: "17.1.2025"},
        {id: 7, fileName: 'File name 7', matter: "Nuto", lastUpdated: "17.1.2025"},
        {id: 8, fileName: 'File name 8', matter: "Nuto", lastUpdated: "17.1.2025"},
        {id: 9, fileName: 'File name 9', matter: "Nuto", lastUpdated: "17.1.2025"}
    ];

    const columns: GridColDef<DocumentRow>[] = [
        {field: 'id', headerName: 'ID', width: 90, headerClassName: 'super-app-theme--header'},
        {field: 'fileName', headerName: t('documents.table.header.fileName'), flex: 1, headerClassName: 'super-app-theme--header'},
        {field: 'lastUpdated', headerName: t('documents.table.header.lastUpdated'), flex: 1, headerClassName: 'super-app-theme--header'},
        {field: 'matter', headerName: t('documents.table.header.matter'), flex: 1, headerClassName: 'super-app-theme--header'},
        {
            field: 'download',
            headerName: t('common.actions.download'),
            width: 90,
            headerClassName: "super-app-theme--header",
            sortable: false,
            renderCell: (params: GridRenderCellParams<DocumentRow>) => (
                <IconButton
                    onClick={() => console.info(params.row)}
                    color="primary"
                    aria-label="download"
                >
                    <DownloadIcon/>
                </IconButton>
            )
        }
    ];

    return (
        <Box sx={{height: 400, width: '100%'}}>
            <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 5,
                        },
                    },
                }}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
                sx={{
                    "& .super-app-theme--header": {
                        backgroundColor: '#fffcf8'
                    }
                }}
            />
        </Box>
    )
}
